export default {"src":"/_next/static/media/request-up-low.51407286.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};